var baseUrl = process.env.REACT_APP_API_URL || process.env.NEXT_PUBLIC_API_URL || process.env.API_URL || '';
var recaptcha_key = process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY || process.env.NEXT_PUBLIC_RECAPTCHA_PUBLIC_KEY || process.env.RECAPTCHA_PUBLIC_KEY || '';

// fake authentication state
var forcedLogin = true;
// Market for API
var API_MARKET = 'website';
var DOWNLOAD_RANGE = 6; // download new items when the there are left 24 elements to scroll;
var RECAPTCHA_SITE_KEY = '6LcdrukUAAAAAEeutI8zeoJ3BhbXnMF0QGqWalOu';
var RECAPTCHA_ENTERPRISE_SITE_KEY = '6LdM2s8cAAAAAN7jqVXAqWdDlQ3Qca88ke3xdtpR';
var RECAPTCHA_SCORE_THRESHOLD = 0.8;
var DEFAULT_LOCALE = 'en';
var LANGUAGE_COOKIE_NAME = 'language';
var CURRENT_LANGUAGE_COOKIE_NAME = 'currentLanguage';
var FONT_COLLECTIONS = 'Font collections';
var MEME_TEMPLATES_ID = 'meme_templates';
var SHUTTERSTOCK_TYPE = 'shutterstock_photo';
var UNSPLASH_TYPE = 'unsplash_photo';
var UNSPLASH_WEB_URL = 'https://unsplash.com/?utm_source=picsart&utm_medium=referral';
var HASHTAG_SCROLL_VALUE = 188;
var FTE_FETCH_COUNT = 60;
var DEFAULT_MAX_AGE = 30 * 24 * 3600000;
var USER_KEY_COOKIE_NAME = 'user_key';
var USER_EMAIL_COOKIE_NAME = 'user_email';
var IS_SUBSCRIBED_COOKIE_NAME = 'is_subscribed';
var GT_USER_ID_COOKIE_NAME = 'gtm_user_id';
var SOCIAL_REQUEST_HEADER_TOKEN = 'hI3KTwebV5yr2Gj';
var TEXT_PRESETS = 'text_presets';
var TEXT_STYLE = 'text_style';
var MORE_PRESETS = "more_".concat(TEXT_PRESETS);
var FONT_COLLECTION = 'font_collections';
var MORE_COLLECTIONS = "more_".concat(FONT_COLLECTION);
var ICON_WIDTH = 56;
var ANALYTICS_SEARCH_RESULTS = {
  noResult: 'no_search_result',
  serverIssue: 'server_issue',
  success: 'success'
};
var RECENT_ACTIVITIES = {
  photo: 'recentActivitiesPhotos',
  sticker: 'recentActivitiesStickers'
};
var ANALITICS_SOURCES = {
  growth: 'growth',
  photoEditor: 'photo-editor',
  videoEditor: 'video-editor',
  monetization: 'monetization'
};
var allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
var REGEXP_FOR_IMAGES = /\.(jpeg|jpg|gif|png)(\\?.*)$/;
var X_API_KEY = 'x-api-key';
var KeyBoardKeys = /*#__PURE__*/function (KeyBoardKeys) {
  KeyBoardKeys["Enter"] = "Enter";
  KeyBoardKeys["Spacebar"] = "Spacebar";
  KeyBoardKeys["EmptySpacebar"] = " ";
  return KeyBoardKeys;
}({});
var KeyboardKeyCodes = /*#__PURE__*/function (KeyboardKeyCodes) {
  KeyboardKeyCodes[KeyboardKeyCodes["Enter"] = 13] = "Enter";
  KeyboardKeyCodes[KeyboardKeyCodes["Spacebar"] = 32] = "Spacebar";
  return KeyboardKeyCodes;
}({});
var TOP_NAVIGATION_EXPERIMENT_ID = 'LBI_JENfSg-lIT_-WSyOJw';
var TOP_NAVIGATION_EXPERIMENT_COOKIE_NAME = 'top-navigation-experiment-variant';
var LANGUAGE_HEADER_KEY = 'language-code';

export { ANALITICS_SOURCES, ANALYTICS_SEARCH_RESULTS, API_MARKET, CURRENT_LANGUAGE_COOKIE_NAME, DEFAULT_LOCALE, DEFAULT_MAX_AGE, DOWNLOAD_RANGE, FONT_COLLECTION, FONT_COLLECTIONS, FTE_FETCH_COUNT, GT_USER_ID_COOKIE_NAME, HASHTAG_SCROLL_VALUE, ICON_WIDTH, IS_SUBSCRIBED_COOKIE_NAME, KeyBoardKeys, KeyboardKeyCodes, LANGUAGE_COOKIE_NAME, LANGUAGE_HEADER_KEY, MEME_TEMPLATES_ID, MORE_COLLECTIONS, MORE_PRESETS, RECAPTCHA_ENTERPRISE_SITE_KEY, RECAPTCHA_SCORE_THRESHOLD, RECAPTCHA_SITE_KEY, RECENT_ACTIVITIES, REGEXP_FOR_IMAGES, SHUTTERSTOCK_TYPE, SOCIAL_REQUEST_HEADER_TOKEN, TEXT_PRESETS, TEXT_STYLE, TOP_NAVIGATION_EXPERIMENT_COOKIE_NAME, TOP_NAVIGATION_EXPERIMENT_ID, UNSPLASH_TYPE, UNSPLASH_WEB_URL, USER_EMAIL_COOKIE_NAME, USER_KEY_COOKIE_NAME, X_API_KEY, allowedTypes, baseUrl, forcedLogin, recaptcha_key };
//# sourceMappingURL=index.js.map
